var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown"},[_c(_vm.togglerTag,{tag:"component",class:['dropdown-toggle', _vm.togglerClass]},[_vm._t("toggler")],2),_c('div',{class:['dropdown-box', _vm.boxClass]},[_c('div',{class:['dropdown-box__content box p-2 dark:bg-dark-6', _vm.contentClass]},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }